import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";

export const DEFAULT_QUERY_DATA = {
    CurrencyId: undefined,
};

export const generateQueryFormConfig = (options?: any): FormConfigType => [
    {
        title: "币种",
        field: "CurrencyId",
        type: "select",
        placeholder: "请选择币种",
        options: options?.currencyOptions || [],
        fieldNames: { label: 'name', value: 'id' },
        allowClear: true,
        style: { width: 200 },
    },
];

export const generateTableColumns = (): ColumnsType => [
    {
        title: "ID",
        dataIndex: "Id",
        key: "Id",
        width: 80,
    },
    {
        title: "货币代码",
        dataIndex: "CurrencyCode",
        key: "CurrencyCode",
    },
    {
        title: "最小限额",
        dataIndex: "MinLimit",
        key: "MinLimit",
    },
    {
        title: "最大限额",
        dataIndex: "MaxLimit",
        key: "MaxLimit",
    },
    {
        title: "手续费%",
        dataIndex: "ServiceFeeRate",
        key: "ServiceFeeRate",
    },
    {
        title: "手续费优惠%",
        dataIndex: "ServiceFeeDiscount",
        key: "ServiceFeeDiscount",
    },
    {
        title: "通道费(USD)",
        dataIndex: "ChannelFee",
        key: "ChannelFee",
    },
    {
        title: "通道费优惠",
        dataIndex: "ChannelFeeDiscount",
        key: "ChannelFeeDiscount",
    },
    {
        title: "汇率滑点",
        dataIndex: "ExchangeRateSlippage",
        key: "ExchangeRateSlippage",
    },
    {
        title: "排序",
        dataIndex: "Sort",
        key: "Sort",
        width: 100,
    }
];
